import React, { useContext, useState, useEffect } from 'react'; 
import '../styles/Panier.css';
import { PanierContext } from '../context/PanierContext';
import { useNavigate } from 'react-router-dom';
import { asset } from '../services/api';

function Panier() {
  const { panier, supprimerProduit, modifierQuantite } = useContext(PanierContext);
  const navigate = useNavigate();
  const [lang, setLang] = useState(localStorage.getItem("lang") || "fr");

  // 🔄 Mise à jour de la langue si elle change ailleurs
  useEffect(() => {
    const updateLang = () => setLang(localStorage.getItem("lang") || "fr");
    window.addEventListener("langChanged", updateLang);
    return () => window.removeEventListener("langChanged", updateLang);
  }, []);

  const [editIndex] = useState(null);
  const [nouvelleQuantite] = useState(1);

  const resolveImage = (item) => {
    const raw = item.image ?? item.img ?? item.photo ?? '';
    if (!raw) return '/icons/monpanier.png';
    if (raw.startsWith('http') || raw.startsWith('data:')) return raw;
    return asset(raw);
  };

  const total = panier.reduce((acc, item, index) => {
    const quantite = editIndex === index ? parseFloat(nouvelleQuantite || 0) : item.quantite;
    return acc + Number(item.prix || 0) * Number(quantite || 0);
  }, 0);

  // 🔤 Traductions FR / MG
  const t = {
    panierVide: lang === "fr" ? "🛒 Votre panier est vide." : "🛒 Tsy misy entana ao anaty sarety.",
    continuerAchats: lang === "fr" ? "← Continuer vos achats" : "← Tohizo ny fividianana",
    votrePanier: lang === "fr" ? "Votre Panier" : "Sarety misy entana",
    etapes: [
      lang === "fr" ? "✔ Vérifier la commande" : "✔ Hamarino ny baiko",
      lang === "fr" ? "Adresse" : "Adiresy",
      lang === "fr" ? "Confirmer la commande" : "Manamafy ny baiko"
    ],
    prixUnitaire: lang === "fr" ? "Prix unitaire" : "Vidiny isaky ny entana",
    total: lang === "fr" ? "Total" : "Totalin'ny entana",
    totalGeneral: lang === "fr" ? "Total général" : "Total rehetra",
    passerPaiement: lang === "fr" ? "Passer au paiement" : "Manao fandoavam-bola"
  };

  return (
    <div className="panier-container">
      {panier.length === 0 ? (
        <div className="panier-vide">
          <p>{t.panierVide}</p>
          <button onClick={() => navigate('/produits')} className="continuer-button">
            {t.continuerAchats}
          </button>
        </div>
      ) : (
        <>
          <h2>{t.votrePanier}</h2>

          <div className="etapes-panier">
            {t.etapes.map((etape, index) => (
              <div className={`etape ${index === 0 ? 'active' : ''}`} key={index}>{etape}</div>
            ))}
          </div>

          <div className="panier-liste">
            {panier.map((item) => (
              <div className="panier-item" key={item.id}>
                <img
                  src={resolveImage(item)}
                  alt={item.nom}
                  className="panier-img"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = '/icons/monpanier.png';
                  }}
                />
                <div className="panier-info">
                  <h3>{item.nom}</h3>
                  <div className="panier-quantite">
                    <button
                      onClick={() => {
                        const newQty = Math.max(1, Math.floor(item.quantite - 1));
                        modifierQuantite(item.id, newQty);
                      }}
                    >
                      −
                    </button>
                    <input type="number" value={Math.floor(item.quantite)} readOnly />
                    <button
                      onClick={() => {
                        const newQty = Math.floor(item.quantite + 1);
                        modifierQuantite(item.id, newQty);
                      }}
                    >
                      +
                    </button>
                  </div>

                  <p>{t.prixUnitaire} : {Number(item.prix || 0).toLocaleString()} Ar</p>
                  <p>{t.total} : {(Number(item.prix || 0) * Number(item.quantite || 0)).toLocaleString()} Ar</p>
                </div>
                <button className="btn-supprimer" onClick={() => supprimerProduit(item.id)}>
                  🗑
                </button>
              </div>
            ))}

            <div className="panier-total">
              <strong>{t.totalGeneral} : {Number(total || 0).toLocaleString()} Ar</strong>
            </div>

            <div className="panier-actions">
              <button onClick={() => navigate('/produits')} className="continuer-button">
                {t.continuerAchats}
              </button>
              <button onClick={() => navigate('/information')} className="payer-button">
                {t.passerPaiement}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Panier;
